<template>
  <div>
    <base-header class="pb-8 pt-3">
      <!-- Card stats -->
      <b-row>
        <b-col md="3"></b-col>
      </b-row>
    </base-header>

    <b-container fluid class="mt--6">
      <b-row>
        <b-col>
          <div
            class="card card-flush shadow-sm mb-xl-8 animate__animated animate__fadeIn"
          >
            <div class="card-header border-0">
              <div class="row">
                <div class="col-md-6">
                  <h3
                    class="card-title align-items-start flex-column w-lg-50 mb-0"
                  >
                    <div class="w-lg-50 col-6 px-0">
                      <div class="d-flex justify-content-end">
                        <input
                          type="text"
                          v-model="pagination.find"
                          class="form-control form-control-sm form-control-solid"
                          placeholder="Buscar nombre o rfc"
                          name="card_cvv"
                          :class="{ 'bg-light-warning': pagination.find != '' }"
                        />
                        <div class="position-absolute mt-1 mr-2">
                          <i
                            v-if="pagination.find == ''"
                            class="fa fa-search text-secondary"
                          ></i>
                          <i
                            v-if="pagination.find != ''"
                            @click="pagination.find = ''"
                            class="fa fa-times-circle text-danger c-pointer"
                          ></i>
                        </div>
                      </div>
                    </div>
                    <!-- <span class="text-muted mt-1 fw-bold fs-7">Over 500 members</span> -->
                  </h3>
                </div>
                <div class="col-md-6 text-right">
                  <router-link
                    :to="`/catalogos/sucursales/editar-crud`"
                    class="btn btn-primary btn-sm"
                  >
                    <i class="fa fa-pencil"></i>
                  </router-link>
                </div>
              </div>
            </div>
            <div class="card-body py-0">
              <div class="table-responsive">
                <table
                  class="getting table align-items-center table-flush table-sm table-hover"
                >
                  <thead class="thead-light">
                    <tr
                      class="fw-bold fs-7 text-gray-500 border-bottom border-gray-200 py-4"
                    >
                      <!-- <th class="w-25px">
                  <div class="form-check form-check-sm form-check-custom form-check-solid">
                    <input class="form-check-input" type="checkbox" value="1" data-kt-check="true" data-kt-check-target=".widget-9-check">
                  </div>
                </th> -->
                      <th class="min-w-100px">Id</th>
                      <th class="min-w-100px">Foto</th>
                      <th class="min-w-100px">Name</th>
                      <th class="min-w-100px">RFC</th>
                      <th class="text-center">Vigencia Sello</th>
                      <th class="text-center">F. Global</th>
                      <th class="text-center">Estatus</th>
                      <th class="min-w-100px text-end">Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, kr) in elements" :key="kr" class="">
                      <td>{{ item.id }}</td>
                      <td>{{ item.nombre }}</td>
                      <td>{{ item.razon_social }}</td>
                      <td>{{ item.rfc }}</td>
                      <td class="text-center">
                        {{
                          getSelloByRFC(item.rfc)
                            ? `${moment(
                                getSelloByRFC(item.rfc).valid_to
                              ).format("DD/MM/YYYY")}

                              [${moment(getSelloByRFC(item.rfc).valid_to).diff(
                                moment(),
                                "days"
                              )} días]
                              `
                            : ""
                        }}
                      </td>
                      <td class="text-center">
                        <i
                          v-if="item.factura_global"
                          class="fas fa-check-circle text-success"
                        ></i>
                      </td>
                      <td class="text-center">
                        <sucursal-state
                          displayMode="current-inline"
                          :cancel="item.cancel"
                        />
                      </td>
                      <td>
                        <div class="d-flex justify-content-end flex-shrink-0">
                          <!-- <a href="#" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1">
                      <span class="svg-icon svg-icon-3">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                          <path d="M17.5 11H6.5C4 11 2 9 2 6.5C2 4 4 2 6.5 2H17.5C20 2 22 4 22 6.5C22 9 20 11 17.5 11ZM15 6.5C15 7.9 16.1 9 17.5 9C18.9 9 20 7.9 20 6.5C20 5.1 18.9 4 17.5 4C16.1 4 15 5.1 15 6.5Z" fill="black"></path>
                          <path opacity="0.3" d="M17.5 22H6.5C4 22 2 20 2 17.5C2 15 4 13 6.5 13H17.5C20 13 22 15 22 17.5C22 20 20 22 17.5 22ZM4 17.5C4 18.9 5.1 20 6.5 20C7.9 20 9 18.9 9 17.5C9 16.1 7.9 15 6.5 15C5.1 15 4 16.1 4 17.5Z" fill="black"></path>
                        </svg>
                      </span>
                    </a> -->
                          <!-- <router-link :to="`/catalogos/empresas/${item.id}`" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"><i class="fa-solid fa-pencil"></i></router-link> -->
                          <!-- <a :href="`/peritajes/${item.id}`" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1">
                      <i class="fa-solid fa-pencil"></i>
                    </a> -->
                          <!-- <button
                            @click="setUser(item)"
                            class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
                          >
                            <i class="fa-solid fa-pencil"></i>
                          </button> -->
                          <!-- <a
                      @click="cancel(item)"
                      href="#"
                      class="btn btn-icon btn-bg-light btn-active-color-danger btn-sm"
                    >
                      <i class="fa-solid fa-trash-can"></i>
                    </a> -->
                          <router-link
                            :to="`/catalogos/sucursales/${item.id}`"
                            class="btn btn-primary btn-sm"
                          >
                            <i class="fa fa-pencil"></i>
                          </router-link>
                          <button-delete
                            :cancel="item.cancel"
                            @onDelete="cancel(item)"
                          />
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="card-footer pt-2 d-flex justify-content-between">
              <div class="row">
                <label for="" class="col">Registros por página:</label>
                <select
                  v-model="pagination.limit"
                  class="col form-control form-control-sm"
                >
                  <option value="15">15</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </div>
              <ul class="pagination">
                <li class="page-item previous">
                  <button
                    @click="pagination.page = 1"
                    :disabled="pagination.page <= 1"
                    class="page-link"
                  >
                    <i class="fas fa-angle-left"></i>
                  </button>
                </li>
                <li class="page-item">
                  <button
                    v-if="pagination.page > 2"
                    @click="pagination.page += -2"
                    class="page-link"
                  >
                    {{ pagination.page - 2 }}
                  </button>
                </li>
                <li class="page-item">
                  <button
                    v-if="pagination.page > 1"
                    @click="pagination.page += -1"
                    class="page-link"
                  >
                    {{ pagination.page - 1 }}
                  </button>
                </li>
                <li class="page-item active">
                  <a href="#" class="page-link">{{ pagination.page }}</a>
                </li>
                <li class="page-item">
                  <button
                    v-if="Math.ceil(pagination.total / pagination.limit) > 1"
                    @click="pagination.page += +1"
                    class="page-link"
                  >
                    {{ pagination.page + 1 }}
                  </button>
                </li>
                <li class="page-item">
                  <button
                    v-if="Math.ceil(pagination.total / pagination.limit) > 2"
                    @click="pagination.page += +2"
                    class="page-link"
                  >
                    {{ pagination.page + 2 }}
                  </button>
                </li>
                <li class="page-item next">
                  <button
                    @click="Math.ceil(pagination.total / pagination.limit)"
                    :disabled="
                      Math.ceil(pagination.total / pagination.limit) <= 1
                    "
                    class="page-link"
                  >
                    <i class="fas fa-angle-right"></i>
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import moment from "moment";
import SucursalState from "@/components/IDBRICS/SucursalState";
import ButtonDelete from "@/components/IDBRICS/tools/ButtonDelete";

import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    SucursalState,
    ButtonDelete,
  },
  data: function () {
    return {
      moment: moment,
      getting: false,
      working: false,
      pagination: {
        page: 1,
        limit: 15,
        total: 0,
        columns: [
          "id",
          "razon_social",
          "nombre",
          "rfc",
          "regimen_fiscal",
          "codigo_postal",
          "serie",
          "consecutivo",
          "factura_global",
          "dif_horaria",
          "cancel",
        ],
        where: null,
        find: "",
        order_by: "",
        order_direction: "",
        data_search: "",
      },
      elements: [],
    };
  },
  watch: {
    "pagination.find": function (val) {
      this.getSucursales();
    },
  },
  computed: {
    ...mapGetters(["getSelloByRFC"]),
  },
  async beforeMount() {
    this.getSucursales();
    this.apiGetSellos();
  },
  methods: {
    ...mapActions(["apiGetSellos"]),
    getSucursales() {
      this.getting = true;

      this.$api
        .get(`sucursales`, {
          params: this.pagination,
        })
        .then((response) => {
          this.elements = response.data.rows;
        })
        .catch((e) => {
          this.$notiflix.Report.failure(
            "Error Interno",
            "No fue posible obtener el recurso solicitado, serás dirigido al inicio y puedes intentarlo nuevamente.",
            "Entendido",
            () => {
              this.$router.push("/");
            }
          );
        })
        .then(() => (this.getting = false));

      // this.$api
      //   .get("sucursales")
      //   .then(response => {
      //     if (response.status == 200) {
      //       this.elements = response.data;
      //     }
      //   })
      //   .catch(e => console.error(e));
    },
    edit(item) {
      console.log(item.row);
      this.$router.push({ path: `/catalogos/sucursales/${item.row.id}` });
    },
    cancel(item) {},
  },
};
</script>
